import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "button" }

import Icon from "@/components/UI/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckItem',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Icon, {
          name: "check",
          size: 8,
          color: "#E9EBF3"
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})